import { fromString, toString } from 'uint8arrays';
export function base64urlToJSON(s) {
    return JSON.parse(toString(fromString(s, 'base64url')));
}
export function JSONToBase64Url(json) {
    return toString(fromString(JSON.stringify(json)), 'base64url');
}
//# sourceMappingURL=uint8array-utils.js.map